export const WEEKDAYS = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

/** ISO string for today at the given local HH:mm */
export function todayAtTime(time: string): string {
  const d = new Date();
  const parts = time.split(':').map(Number);
  const h = parts[0] ?? 0;
  const m = parts[1] ?? 0;
  d.setHours(h, m, 0, 0);
  return d.toISOString();
}

export function formatDateTime(value: string): string {
  if (!value) return '';
  const d = new Date(value);
  const day = WEEKDAYS[d.getDay()];
  const date = d.getDate();
  const month = MONTHS[d.getMonth()];
  const year = d.getFullYear();
  const hours = String(d.getHours()).padStart(2, '0');
  const mins = String(d.getMinutes()).padStart(2, '0');
  return `${day} ${date} ${month} ${year} at ${hours}:${mins}`;
}

export function formatDateOnly(d: Date): string {
  const day = WEEKDAYS[d.getDay()];
  const date = d.getDate();
  const month = MONTHS[d.getMonth()];
  const year = d.getFullYear();
  return `Today \u2014 ${day} ${date} ${month} ${year}`;
}

export function extractTimeFromDateTimeParam(raw: string): string {
  const parsed = new Date(raw);
  if (!Number.isNaN(parsed.getTime())) {
    const h = String(parsed.getHours()).padStart(2, '0');
    const m = String(parsed.getMinutes()).padStart(2, '0');
    return `${h}:${m}`;
  }
  const match = raw.match(/T(\d{2}:\d{2})/);
  return match?.[1] ?? '';
}
